// extracted by mini-css-extract-plugin
module.exports = {"principal-number":"currencySymbol_principal-number__jTmN8","second-number":"currencySymbol_second-number__qBSgu","decimal":"currencySymbol_decimal__5xtLT"};